export default (value?: string|number, decimal:number=2,empty:string='--') => {
    if(value!==0 && (!value || value==='NaN')){
        return empty
    }
    if(typeof value=='string'){
        if((value.match(/\.[0-9]+$/)?.[0] || '').length<=decimal+1){
            return value
        }
        value=parseFloat(value);
    }
    if(value%1){
        return value.toFixed(decimal);
    }
    return value+'';
}
